import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: 'inicial' | 'concorrentes' | 'atributos' | 'analise';
}
const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep
}) => {
  const steps = [{
    key: 'inicial',
    label: 'Informações'
  }, {
    key: 'concorrentes',
    label: 'Concorrentes'
  }, {
    key: 'atributos',
    label: 'Atributos'
  }, {
    key: 'analise',
    label: 'Relatório'
  }];
  const getStepStatus = (stepKey: string) => {
    const stepOrder = {
      inicial: 0,
      concorrentes: 1,
      atributos: 2,
      analise: 3
    };
    const currentStepIndex = stepOrder[currentStep];
    const thisStepIndex = stepOrder[stepKey];
    if (thisStepIndex < currentStepIndex) return 'completed';
    if (thisStepIndex === currentStepIndex) return 'current';
    return 'upcoming';
  };
  return <div className="mb-8" data-id="element-1228">
      <div className="flex items-center justify-between" data-id="element-1229">
        {steps.map((step, index) => <Fragment key={step.key} data-id="element-1230">
            <div className="flex flex-col items-center" data-id="element-1231">
              <div className={`w-8 h-8 flex items-center justify-center rounded-full 
                  ${getStepStatus(step.key) === 'completed' ? 'bg-gray-400 text-white' : getStepStatus(step.key) === 'current' ? 'bg-black text-white' : 'bg-white text-gray-900 border border-gray-300'}`} data-id="element-1232">
                {getStepStatus(step.key) === 'completed' ? <Check size={16} data-id="element-1233" /> : index + 1}
              </div>
              <span className={`mt-2 text-xs font-medium 
                  ${getStepStatus(step.key) === 'completed' ? 'text-gray-500' : getStepStatus(step.key) === 'current' ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-1234">
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && <div className={`flex-1 h-0.5 
                  ${getStepStatus(steps[index + 1].key) === 'upcoming' ? 'bg-gray-200' : getStepStatus(steps[index].key) === 'current' ? 'bg-gray-300' : 'bg-gray-400'}`} data-id="element-1235"></div>}
          </Fragment>)}
      </div>
    </div>;
};
export default StepIndicator;